import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { HeaderCTACard, PageHeader } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, SxProps, Theme } from '@mui/material';

import { useAgentContext } from './DashboardHeader.agentContext';

const HEADER_STRINGS = appStrings.modules.lifeReadiness.header;

type DashboardHeaderProps = Readonly<{
  rightContent?: ReactNode;
}>;

export const DashboardHeader = ({ rightContent }: DashboardHeaderProps) => {
  useAgentContext();
  const navigate = useNavigate();

  return (
    <Box sx={containerSx}>
      <HeaderCTACard
        id="life-readiness-take-assessment-button"
        title={HEADER_STRINGS.title}
        buttonText={HEADER_STRINGS.buttonText}
        buttonOnClick={() => navigate(`${APP_ROUTE.LIFE_READINESS}/quiz`)}
        imageUrl={'/images/stickers/lifeReadiness/life-readiness-categories.svg'}
        rightContent={rightContent}
      />

      <PageHeader
        title={HEADER_STRINGS.title}
        subtitle={HEADER_STRINGS.description}
        borderColor="Gray/950"
        maxWidth={null}
        sxOverrides={{ container: pageHeaderSx }}
      />
    </Box>
  );
};

const containerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '936px',
};

const pageHeaderSx: SxProps<Theme> = ({ backrs }) => ({
  containerType: 'normal',
  alignSelf: 'stretch',
  mb: backrs.spacing['spacing-4xl'],
});
